var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.58 8.7425L13.5725 8.7575C13.6025 8.51 13.6325 8.255 13.6325 8C13.6325 7.745 13.61 7.505 13.58 7.2575L13.5875 7.2725L15.4175 5.8325L13.595 2.6675L11.4425 3.5375L11.45 3.545C11.06 3.245 10.6325 2.99 10.1675 2.795H10.175L9.83003 0.5H6.17753L5.84753 2.8025H5.85503C5.39003 2.9975 4.96253 3.2525 4.57253 3.5525L4.58003 3.545L2.42003 2.6675L0.590027 5.8325L2.42003 7.2725L2.42753 7.2575C2.39753 7.505 2.37503 7.745 2.37503 8C2.37503 8.255 2.39753 8.51 2.43503 8.7575L2.42753 8.7425L0.852527 9.98L0.605027 10.175L2.42753 13.325L4.58753 12.4625L4.57253 12.4325C4.97003 12.74 5.39753 12.995 5.87003 13.19H5.84753L6.18503 15.5H9.82253C9.82253 15.5 9.84503 15.365 9.86753 15.185L10.1525 13.1975H10.145C10.61 13.0025 11.045 12.7475 11.4425 12.44L11.4275 12.47L13.5875 13.3325L15.41 10.1825C15.41 10.1825 15.305 10.0925 15.1625 9.9875L13.58 8.7425ZM8.00003 10.625C6.55253 10.625 5.37503 9.4475 5.37503 8C5.37503 6.5525 6.55253 5.375 8.00003 5.375C9.44753 5.375 10.625 6.5525 10.625 8C10.625 9.4475 9.44753 10.625 8.00003 10.625Z",
    fill: "#6FCF97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.8fa49d131612b9db52668ddd52121512.svg";
export { ForwardRef as ReactComponent };